import backgroundTile from "@rosette/assets/src/game/halloween/background_tile.png";
import lightPieceSelected from "@rosette/assets/src/game/halloween/light_piece_selected.png";
import lightPieceUnselected from "@rosette/assets/src/game/halloween/light_piece_unselected.png";
import darkPieceSelected from "@rosette/assets/src/game/halloween/dark_piece_selected.png";
import darkPieceUnselected from "@rosette/assets/src/game/halloween/dark_piece_unselected.png";
import board from "@rosette/assets/src/game/halloween/board.png";
import boardJSON from "@rosette/assets/src/game/halloween/board.json";
import diceUp1 from "@rosette/assets/src/game/halloween/dice/up1.png";
import diceUp2 from "@rosette/assets/src/game/halloween/dice/up2.png";
import diceUp3 from "@rosette/assets/src/game/halloween/dice/up3.png";
import diceDown1 from "@rosette/assets/src/game/halloween/dice/down1.png";
import diceDown2 from "@rosette/assets/src/game/halloween/dice/down2.png";
import diceDown3 from "@rosette/assets/src/game/halloween/dice/down3.png";
import selectedShadow from "@rosette/assets/src/game/halloween/dice/selected_shadow.png";
import unselectedShadow from "@rosette/assets/src/game/halloween/dice/unselected_shadow.png";
import { GameThemeType } from "@rosette/ts/src/business/game/theme/GameThemeType.js";
import type { BoardSpecification } from "@/components/game/theme/GameThemeSettings.js";
import { GameThemeSettings } from "@/components/game/theme/GameThemeSettings.js";


export class HalloweenGameThemeSettings extends GameThemeSettings {
    constructor() {
        super();
        this.themeType = GameThemeType.HALLOWEEN;
        this.backgroundTile = backgroundTile;
        this.lightPieceSelected = lightPieceSelected;
        this.lightPieceUnselected = lightPieceUnselected;
        this.darkPieceSelected = darkPieceSelected;
        this.darkPieceUnselected = darkPieceUnselected;
        this.board = board;
        this.boardJSON = boardJSON as BoardSpecification;
        this.diceUpImages = [diceUp1, diceUp2, diceUp3];
        this.diceDownImages = [diceDown1, diceDown2, diceDown3];
        this.diceSelectedShadow = selectedShadow;
        this.diceUnselectedShadow = unselectedShadow;
    }

    getFireworkColour(): { r: number; g: number; b: number } {
        return Math.random() > 0.5 ? {
            r: 66, g: 101, b: 255,
        } : {
            r: 255, g: 200, b: 36,
        };
    }
}
